module.exports = __webpack_public_path__ + "images/halloween_lp/step1-NumberIcon_33d0cf6826f6a2abdb9a7e4d4af86943.png";